export const INPUT_REGEX = /^[0-9]*\.?([0-9]{0,6})$/g,
  VALUE_LENGTH_REGEX = /^\d+(\.?\d{7,})$/g,
  SLIPPAGE_INPUT_REGEX = /^[0-9]*\.?([0-9]{0,2})$/g;
